export default {
      id: "i-bpif-growthcost-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/sprite.svg#i-bpif-growthcost",
      toString: function () {
        return this.url;
      }
    }